import React from 'react';
import app from './modules/app';
import order from './modules/order';

export type RootStore = {
  app: typeof app;
  order: typeof order;
};

export const store: RootStore = {
  app,
  order
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { app, order };
